module.exports = __webpack_public_path__ + "img/warning.482ff71c.svg";